import { useDestinationContext } from '@/src/contexts'

import PopularRoutes from './popularRoutes'

const PopularRoutesWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const routes = sections.popularRoutes
    if (!routes?.length) return null

    return <PopularRoutes routes={routes} />
}

export default PopularRoutesWrapper
